import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getValuationTypes, saveValuationTypesBatch } from '../../api/agenda';
import type { ValuationType } from '../../types/Agenda';
import { t } from '../../i18n/t';

const columnDefs: ColDef<ValuationType>[] = [
  {
    field: 'valuationTypeId',
    headerName: t('valuationTypes.columns.valuationTypeId'),
    width: 110,
    // Natural PK: editable on Add only.
    editable: (p: EditableCallbackParams<ValuationType>) =>
      (p.data as { __status?: string } | undefined)?.__status === 'added',
    cellDataType: 'number',
    sort: 'asc',
  },
  {
    field: 'valuationTypeCode',
    headerName: t('valuationTypes.columns.valuationTypeCode'),
    width: 160,
    editable: true,
  },
  {
    field: 'valuationTypeName',
    headerName: t('valuationTypes.columns.valuationTypeName'),
    flex: 1,
    minWidth: 200,
    editable: true,
  },
  {
    field: 'isActive',
    headerName: t('valuationTypes.columns.isActive'),
    width: 110,
    editable: true,
    cellDataType: 'boolean',
  },
];

const newDefaults = (): Partial<ValuationType> => ({
  valuationTypeId: 0,
  valuationTypeCode: '',
  valuationTypeName: '',
  isActive: true,
});

export function ValuationTypesPage() {
  return (
    <LopCrudPage<ValuationType>
      resourceCode="valuationTypes"
      titleKey="valuationTypes.pageTitle"
      idField="valuationTypeId"
      getRows={getValuationTypes}
      saveBatch={(added, modified, deletedIds) =>
        saveValuationTypesBatch(added, modified, deletedIds as number[])
      }
      columnDefs={columnDefs}
      newRowDefaults={newDefaults}
    />
  );
}
